import { NewsTickData } from '../../types/api/NewsTypes';
import { BySymbolByTradingDay, changeBySymbolByTradingDayState, Requested } from '../../types/api/Types';
import { NewsActions, REQUEST_SHARE_NEWS_FAILURE, REQUEST_SHARE_NEWS_SUCCESS, REQUEST_SHARE_NEWS_WAITING } from '../../types/redux/NewsTypes';

export interface INewsState {
    newsDoubleMap: BySymbolByTradingDay<
        Requested<
            NewsTickData[]
        >
    >
}

const initialState: INewsState = {
    newsDoubleMap: {}
}

export default function(state: INewsState = initialState, action: NewsActions) {
    switch(action.type) {
        case REQUEST_SHARE_NEWS_WAITING: {
            const { symbol, tradingDay } = action.payload;

            const newNewsDoubleMap = changeBySymbolByTradingDayState(state.newsDoubleMap, symbol, tradingDay, 'waiting');

            const newState: INewsState = {
                ...state,
                newsDoubleMap: newNewsDoubleMap
            };
            return newState;
        }
        case REQUEST_SHARE_NEWS_SUCCESS: {
            const { symbol, tradingDay, newsResponse } = action.payload;
            
            const { feedItems } = newsResponse;
            const newsTickData: NewsTickData[] = feedItems.map(result => ({
                ...result,
                timestamp: result.publishDate,
                symbol,
                tickdata_type: 'News',
                title: result.title,
                link: result.link || ''
            }));

            const newNewsDoubleMap = changeBySymbolByTradingDayState(state.newsDoubleMap, symbol, tradingDay, newsTickData);

            const newState: INewsState = {
                ...state,
                newsDoubleMap: newNewsDoubleMap
            };
            return newState;
        }
        case REQUEST_SHARE_NEWS_FAILURE: {
            const { symbol, tradingDay, error } = action.payload;

            const newNewsDoubleMap = changeBySymbolByTradingDayState(state.newsDoubleMap, symbol, tradingDay, {message: error});

            const newState: INewsState = {
                ...state,
                newsDoubleMap: newNewsDoubleMap
            };
            return newState;
        }
        default: {
            return state;
        }
    }
}